export const ApiDef_FHIRResourceSubtype = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map